import { memo, useMemo } from 'react';
import { Link } from 'foundations-components/transitional/components/Link';
import { List } from 'foundations-components/transitional/components/List';
import useComponentMountMetric from '../metrics/useComponentMountMetric';
import { usePropertyValue } from '../v2/hooks/usePropertyValue';
import { isValidDomain } from '../validation/PropertyValidations';
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
const PropertyInputFiles = () => {
  useComponentMountMetric('PropertyInputFiles');
  const propertyValue = usePropertyValue();
  const value = useMemo(() => {
    const urls = propertyValue ? propertyValue.split(/[;,]+/) : [];
    return urls.filter(url => isValidDomain(url.trim()));
  }, [propertyValue]);
  return /*#__PURE__*/_jsx(List, {
    paddingInlineStart: "0",
    wrapChildren: true,
    children: value.map(url => {
      const match = url.match(/\/([^/]*)$/);
      const fileName = match ? match[1] : '';
      return /*#__PURE__*/_jsxs(Link, {
        href: url,
        external: true,
        children: [' ', fileName, ' ']
      }, url);
    })
  });
};
export default /*#__PURE__*/memo(PropertyInputFiles);